
(function(){
  var TOTAL = 6;
  var answers = {};
  var order = ['bloating','dairy','energy','tried','migration','goal'];
  var current = 0;

  var bar = document.getElementById('bar');
  var stepcount = document.getElementById('stepcount');
  var quiz = document.getElementById('quiz');
  var steps = quiz.querySelectorAll('.step');
  var backBtn = document.getElementById('back');
  var nextBtn = document.getElementById('next');
  var nav = document.querySelector('.nav');
  var emailStep = document.getElementById('emailStep');
  var loading = document.getElementById('loading');
  var result = document.getElementById('result');

  function updateProgress(){
    var pct = (current/TOTAL)*100;
    bar.style.width = pct + '%';
    stepcount.textContent = 'Question ' + Math.min(current+1,TOTAL) + ' of ' + TOTAL;
  }

  function showStep(i){
    steps.forEach(function(s){ s.classList.remove('active'); });
    var s = quiz.querySelector('[data-step="'+i+'"]');
    if(s) s.classList.add('active');
    backBtn.disabled = (i===0);
    var key = order[i];
    nextBtn.disabled = !answers[key];
    nextBtn.textContent = (i===TOTAL-1) ? 'See My Result' : 'Continue';
    updateProgress();
  }

  // option selection
  quiz.querySelectorAll('.opts').forEach(function(group){
    var key = group.getAttribute('data-key');
    group.querySelectorAll('.opt').forEach(function(opt){
      opt.addEventListener('click', function(){
        group.querySelectorAll('.opt').forEach(function(o){ o.classList.remove('sel'); });
        opt.classList.add('sel');
        answers[key] = opt.getAttribute('data-val');
        nextBtn.disabled = false;
      });
    });
  });

  nextBtn.addEventListener('click', function(){
    if(current < TOTAL-1){
      current++;
      showStep(current);
    } else {
      // go to email capture
      quiz.style.display='none';
      nav.style.display='none';
      emailStep.style.display='block';
      bar.style.width='100%';
      stepcount.textContent='Final step';
    }
  });

  backBtn.addEventListener('click', function(){
    if(current>0){ current--; showStep(current); }
  });

  // email
  var emailInput = document.getElementById('email');
  var emailErr = document.getElementById('emailErr');
  document.getElementById('emailSubmit').addEventListener('click', function(){
    var v = emailInput.value.trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){
      emailErr.textContent = 'Please enter a valid email.';
      return;
    }
    emailErr.textContent='';
    // Send to Omnisend via API
    var tags = ['quiz-lead'];
    if(answers.bloating==='heavy'||answers.bloating==='gas') tags.push('bloating-severe');
    if(answers.bloating==='sometimes') tags.push('bloating-moderate');
    if(answers.dairy==='struggle'||answers.dairy==='lactaid') tags.push('dairy-issue');
    if(answers.energy==='crash'||answers.energy==='sluggish') tags.push('energy-crash');
    if(answers.tried==='western'||answers.tried==='both') tags.push('tried-probiotics');
    if(answers.tried==='home') tags.push('home-remedies');
    if(answers.migration==='moved') tags.push('immigration-gut');
    if(answers.goal) tags.push('goal-'+answers.goal);
    fetch('https://api.omnisend.com/v3/contacts', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-API-KEY':'6a16832fbb86f4fe41558660-aV14dSkLsWTMjktyEZga6X9MB69oFIOn8mAPQbCtnOCxtw1aMd'},
      body: JSON.stringify({
        identifiers:[{type:'email',id:v,channels:{email:{status:'subscribed',statusDate:new Date().toISOString()}}}],
        tags: tags,
        customProperties: {
          quiz_bloating: answers.bloating||'',
          quiz_dairy: answers.dairy||'',
          quiz_energy: answers.energy||'',
          quiz_tried: answers.tried||'',
          quiz_migration: answers.migration||'',
          quiz_goal: answers.goal||''
        }
      })
    }).catch(function(){});
    emailStep.style.display='none';
    loading.style.display='block';
    stepcount.parentElement.style.display='none';
    setTimeout(buildResult, 1600);
  });

  // ---- Result builder: always recommends 90-day, reasons drawn from answers ----
  function buildResult(){
    var reasons = [];
    var a = answers;

    if(a.bloating==='heavy' || a.bloating==='gas'){
      reasons.push(['You\u2019re unbuttoning your jeans under the table','Heavy and bloated within the hour of a family dinner isn\u2019t \u201cjust how desi food is.\u201d It\u2019s a sign your gut bacteria need support. Rebalancing them is gradual — most people need a steady 8\u201312 weeks, not one bottle, before it holds.']);
    } else if(a.bloating==='sometimes'){
      reasons.push(['Bloating that comes and goes','Some meals wreck you, some don\u2019t — and you can never quite predict which. A full protocol gives your gut the runway to settle into a calmer, steadier baseline instead of riding the rollercoaster.']);
    } else {
      reasons.push(['Staying ahead of it','You\u2019re mostly comfortable now — the goal is keeping it that way. Gut support works as a daily habit built over months, which is exactly what a 90-day run sets up.']);
    }

    if(a.dairy==='struggle' || a.dairy==='lactaid'){
      reasons.push(['Chai gives you life, your stomach gives you grief','You struggle with dairy — or you\u2019ve quietly built your life around avoiding it. Our Lactobacillus Paracasei strain supports dairy digestion and post-meal comfort, and it does its best work given a sustained window, not a quick trial.']);
    } else if(a.dairy==='some'){
      reasons.push(['The dahi is fine, the kheer isn\u2019t','Your dairy response is a guessing game. Consistent daily support across 90 days helps your gut find a steadier rhythm with the foods you grew up on — instead of you memorising which ones are \u201csafe.\u201d']);
    }

    if(a.energy==='crash' || a.energy==='sluggish'){
      reasons.push(['1:45pm, and the wet towel drops over your brain','That post-lunch crash after rice and dal isn\u2019t your sleep or your discipline — your gut and your energy are linked. Supporting digestive balance across a full protocol is the most reliable path to afternoons that don\u2019t fall off a cliff.']);
    }

    if(a.tried==='western' || a.tried==='both'){
      reasons.push(['Align, Culturelle, Seed — none of them stuck','There\u2019s a reason. Those are built for Bacteroides-dominant Western guts. Yours is Prevotella-dominant. Sona is formulated for it — and it deserves the 90 honest days those others never earned from you.']);
    } else if(a.tried==='home'){
      reasons.push(['Jeera water helps — until it doesn\u2019t','Ajwain and hing ease the moment. They don\u2019t rebuild the bacterial strains your gut is missing. A daily protocol works upstream on the actual root, and that\u2019s a weeks-long job, not an afternoon fix.']);
    }

    if(a.migration==='moved'){
      reasons.push(['Your body changed when you moved','You\u2019re not imagining it — research links migration to a measurable shift in South Asian gut composition, with key strains depleted and never replaced. Rebuilding that support is a months-long process by nature.']);
    }

    // goal-driven close — always points at the protocol
    if(a.goal==='longterm'){
      reasons.push(['You want this handled for the long run','That\u2019s precisely what a 90-day run builds: the daily habit locked in, and the full window your gut needs to adjust and hold.']);
    } else if(a.goal==='meals'){
      reasons.push(['You want to eat your mum\u2019s food without the math','No more \u201cI already ate\u201d before you go, no more planning the night around one meal. Getting there is gradual — the protocol gives you the runway, and the guarantee lets you try it with nothing on the line.']);
    } else if(a.goal==='energy'){
      reasons.push(['You want your afternoons back','Sharp at 8am, useless by 2pm, every day — that\u2019s the pattern you want gone. Steady change comes from consistency, and 90 days is the window where most people report it settling in.']);
    } else {
      reasons.push(['You want a flatter, calmer stomach','Not a one-day deflate — a baseline that actually holds. That builds over weeks of consistent support, which is exactly the timeline the protocol is designed around.']);
    }

    // render (cap at 5 for readability)
    var ul = document.getElementById('reasons');
    ul.innerHTML='';
    reasons.slice(0,5).forEach(function(r){
      var li=document.createElement('li');
      li.innerHTML='<span class="tick">✓</span><span><b>'+r[0]+'.</b> '+r[1]+'</span>';
      ul.appendChild(li);
    });

    // ---- Answer-aware EVIDENCE cards ----
    // Pool of real, citeable findings; we surface the ones matching their answers,
    // then backfill to a minimum of 3 so the section never looks thin.
    var evPool = {
      lactose: ['Most South Asians','A majority of South Asians don\u2019t fully digest lactose — estimates commonly run 60\u201380%. It\u2019s not a personal defect; it reflects which gut bacteria are present.','Population studies on lactase non-persistence in South Asian groups'],
      diet:    ['Diet shapes the gut','A landmark study found that long-term diet is one of the strongest forces shaping which bacteria dominate your gut — fiber-rich diets push it toward Prevotella.','Wu et al., 2011, University of Pennsylvania, Science'],
      ethnicity:['Ethnicity matters most','In a controlled comparison, ethnicity was the single largest factor explaining differences in gut bacteria composition between people — bigger than diet alone.','Dwiyanto et al., 2021, Scientific Reports'],
      migration:['Moving changes your gut','Research on South Asians in Canada documents a \u201ctransitional\u201d microbiome after immigration — losing native Prevotella strains as the diet shifts.','UBC microbiome research, 2025'],
      none0:   ['Zero made for us','Despite all of the above, the number of major probiotics formulated specifically for South Asian gut biology has been, until now, zero.','Sona market review']
    };

    var picked = [];
    if(a.dairy==='struggle'||a.dairy==='lactaid'||a.dairy==='some') picked.push(evPool.lactose);
    if(a.migration==='moved') picked.push(evPool.migration);
    if(a.tried==='western'||a.tried==='both') picked.push(evPool.ethnicity);
    // always include the diet mechanism — it's the core explanation
    picked.push(evPool.diet);
    // backfill
    if(picked.indexOf(evPool.ethnicity)<0) picked.push(evPool.ethnicity);
    if(picked.length<3) picked.push(evPool.migration);
    picked.push(evPool.none0);
    // de-dupe + cap at 4
    var seen=[], evOut=[];
    picked.forEach(function(p){ if(seen.indexOf(p[0])<0){seen.push(p[0]); evOut.push(p);} });
    evOut = evOut.slice(0,4);

    var evWrap = document.getElementById('evidence');
    evWrap.innerHTML='';
    evOut.forEach(function(e){
      var d=document.createElement('div'); d.className='ev';
      d.innerHTML='<div class="ev__stat">'+e[0]+'</div><div class="ev__txt">'+e[1]+'</div><div class="ev__cite">'+e[2]+'</div>';
      evWrap.appendChild(d);
    });

    // ---- Answer-aware DEEP sections ----
    var deep=[];
    if(a.dairy==='struggle'||a.dairy==='lactaid'||a.dairy==='some'){
      deep.push(['Because you told us dairy is a problem',
        'You said dairy doesn\u2019t sit right — and you\u2019re far from alone. The issue usually isn\u2019t the milk itself; it\u2019s that your gut is short on the bacteria that help break down lactose. Cutting out chai and paneer manages the symptom. Supporting those bacteria works on the actual cause. Our <strong>Lactobacillus Paracasei</strong> strain is included specifically to support dairy digestion and post-meal comfort — but it needs consistent daily use over weeks, not a pill before each cup.']);
    }
    if(a.energy==='crash'||a.energy==='sluggish'){
      deep.push(['Because you told us about the afternoon crash',
        'That 2pm wall after a rice-and-dal lunch isn\u2019t a willpower problem. Your gut and your energy are more connected than most people realize — a large share of your body\u2019s serotonin is actually produced in the gut. When your microbiome is off, big midday meals hit harder. Supporting digestive balance over a full protocol is the steadiest way to give your afternoons a fair shot.']);
    }
    if(a.tried==='western'||a.tried==='both'){
      deep.push(['Because you told us nothing has worked',
        'Align, Culturelle, Seed, the one with thousands of Amazon reviews — if none of them did anything, that result actually makes sense. They\u2019re formulated and tested largely on Western, Bacteroides-dominant guts. Putting a Western-tuned formula into a Prevotella-dominant gut is the mismatch. It was never that <strong>you</strong> failed the probiotic — the probiotic was built for someone else.']);
    }
    if(a.tried==='home'){
      deep.push(['Because you reach for home remedies',
        'Jeera water, ajwain, hing — they\u2019ve earned their place and they do help in the moment. But they soothe symptoms; they don\u2019t rebuild the specific bacterial strains a Prevotella-dominant gut relies on. Think of Sona as working upstream of where the home remedies act — on the root, daily, over time.']);
    }
    var deepWrap=document.getElementById('deepSections');
    deepWrap.innerHTML='';
    deep.slice(0,2).forEach(function(s){
      var d=document.createElement('div'); d.className='pcallout';
      d.innerHTML='<div class="pcallout__tag">Personalized for you</div><p><strong>'+s[0]+'.</strong> '+s[1]+'</p>';
      deepWrap.appendChild(d);
    });

    loading.style.display='none';
    result.classList.add('active');
    window.scrollTo({top:0,behavior:'smooth'});
  }

  showStep(0);
})();
